import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import * as ReactBootstrap from 'react-bootstrap';
import { useAppContext } from '../../context/AppContext.js';
import Title from '../../components/Title.js';
import ActionsBar from '../../components/ActionsBar.js';
import Button from '../../components/Button.js';
import IconBudgetOperation from '../../components/icons/IconBudgetOperation.js';
import IconStatus from '../../components/icons/IconStatus.js';
import IconCount from '../../components/icons/IconCount.js';
import IconComment from '../../components/icons/IconComment.js';
import BudgetOperationTopPart1 from './BudgetOperationTopPart1.js';
import BudgetOperationTopPart2 from './BudgetOperationTopPart2.js';
import BudgetOperationTopPart3 from './BudgetOperationTopPart3.js';
import BudgetOperationTopPart4 from './BudgetOperationTopPart4.js';
import BudgetOperationTopPart5 from './BudgetOperationTopPart5.js';
import BudgetOperationTopPart6 from './BudgetOperationTopPart6.js';
import BudgetOperationTopAction1 from './BudgetOperationTopAction1.js';
import BudgetOperationTopAction2 from './BudgetOperationTopAction2.js';
import BudgetOperationTopAction3 from './BudgetOperationTopAction3.js';
import ApiService from '../../services/ApiService.js';
import SecurityService from '../../services/SecurityService.js';
import { getWords } from '../../utils/get-words.js';
import { isValid } from '../../utils/is-valid.js';
import { protect } from '../../utils/protect.js';

const BudgetOperationTop = ReactRouterDOM.withRouter(function ({ budgetOperation, data, updateData, validated }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);
  const [action, setAction] = React.useState(null);
  const [actionData, setActionData] = React.useState(null);
  const [actionPath, setActionPath] = React.useState(null);
  const [actionBody, setActionBody] = React.useState(null);
  const [actionValidated, setActionValidated] = React.useState(null);
  const bodyRefAction0 = React.useRef(null);
  const bodyRefAction1 = React.useRef(null);
  const bodyRefAction2 = React.useRef(null);

  const handleAction0 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    setAction({ index: 0 });
    const path = {};
    path.budgetOperationId = budgetOperation.budgetOperationId;
    setActionPath(path);
  }
  const submitAction0 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    if (isValid(bodyRefAction0.current)) {
      try {
        await ApiService.putBudgetOperationSetInRevision(actionPath.budgetOperationId, actionBody);
      }
      catch (error) {
        setError(error);
        return;
      }
      setAction(null);
      setActionPath(null);
      setActionValidated(null);
      window.location.reload();
    }
    else {
      setActionValidated(true);
    }
  }
  const handleAction1 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    setAction({ index: 1 });
    const path = {};
    path.budgetOperationId = budgetOperation.budgetOperationId;
    setActionPath(path);
  }
  const submitAction1 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    if (isValid(bodyRefAction1.current)) {
      try {
        await ApiService.putBudgetOperationSetConfirmed(actionPath.budgetOperationId, actionBody);
      }
      catch (error) {
        setError(error);
        return;
      }
      setAction(null);
      setActionPath(null);
      setActionValidated(null);
      window.location.reload();
    }
    else {
      setActionValidated(true);
    }
  }
  const handleAction2 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    setAction({ index: 2 });
    const path = {};
    path.budgetOperationId = budgetOperation.budgetOperationId;
    setActionPath(path);
  }
  const submitAction2 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    if (isValid(bodyRefAction2.current)) {
      try {
        await ApiService.putBudgetOperationSetSent(actionPath.budgetOperationId, actionBody);
      }
      catch (error) {
        setError(error);
        return;
      }
      setAction(null);
      setActionPath(null);
      setActionValidated(null);
      window.location.reload();
    }
    else {
      setActionValidated(true);
    }
  }
  const updateActionData = function (field, value) {
    setActionData({ ...actionData, [field]: value });
  }
  const updateActionPath = function (field, value) {
    setActionPath({ ...actionPath, [field]: value });
  }
  const updateActionBody = function (field, value) {
    setActionBody({ ...actionBody, [field]: value });
  }
  const cancelAction = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    setAction(null);
    setActionData(null);
    setActionValidated(null);
  }
  
  return (
    <div>
      <div>
        <div className="pb-1 d-flex align-items-center border-bottom">
          <Title level={1} icon={IconBudgetOperation} color="blue" label={words.budgetOperation} />
          <div className="flex-grow-1" />
          <ActionsBar
            actions={[
              { icon: IconStatus, label: words.moveToRevision, color: 'red', onClick: handleAction0, hidden: !(protect(function ([status]) { return status === 'confirmed' }, [ budgetOperation.status ]) && (SecurityService.hasRole('administrator'))) },
              { icon: IconStatus, label: words.confirmCounts, color: 'gold', onClick: handleAction1, hidden: !(protect(function ([status]) { return status === 'inRevision' }, [ budgetOperation.status ]) && (SecurityService.hasRole('officer'))) },
              { icon: IconStatus, label: words.sendCounts, color: 'green', onClick: handleAction2, hidden: !(protect(function ([status]) { return status === 'confirmed' }, [ budgetOperation.status ]) && (SecurityService.hasRole('administrator'))) },
            ]}
          />
        </div>
        <div>
          {budgetOperation ?
            <div className="pb-3">
              <BudgetOperationTopPart1 budgetOperation={budgetOperation} />
            </div> :
            null
          }
          {budgetOperation ?
            <div className="pb-3">
              <BudgetOperationTopPart2 budgetOperation={budgetOperation} />
            </div> :
            null
          }
          {budgetOperation ?
            <div className="pb-3">
              <BudgetOperationTopPart3 budgetOperation={budgetOperation} data={data} updateData={updateData} validated={validated} />
            </div> :
            null
          }
          {budgetOperation ?
            <div className="pb-3">
              <BudgetOperationTopPart4 budgetOperation={budgetOperation} />
            </div> :
            null
          }
          {budgetOperation ?
            <div className="pb-3">
              <BudgetOperationTopPart5 budgetOperation={budgetOperation} data={data} updateData={updateData} validated={validated} />
            </div> :
            null
          }
          {budgetOperation ?
            <div className="pb-3">
              <BudgetOperationTopPart6 budgetOperation={budgetOperation} />
            </div> :
            null
          }
        </div>
      </div>
      {action && action.index === 0 ?
        <ReactBootstrap.Modal
          show={true}
          onHide={() => cancelAction({})}
          scrollable={true}
          centered={true}
         
        >
          <ReactBootstrap.Modal.Header className="pt-2 pb-1 ps-2 pe-3" closeButton={true}>
            <Title level={1} icon={IconStatus} color="red" label={words.moveToRevision} />
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body ref={bodyRefAction0} className="p-0">
            <div className="p-2">
              <BudgetOperationTopAction1 budgetOperation={budgetOperation} />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer className="p-2">
            <div>
              <Button label={words.yes} color="red" onClick={submitAction0} />
            </div>
            <div>
              <Button label={words.no} color="blue" onClick={cancelAction} />
            </div>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal> :
        null
      }
      {action && action.index === 1 ?
        <ReactBootstrap.Modal
          show={true}
          onHide={() => cancelAction({})}
          scrollable={true}
          centered={true}
         
        >
          <ReactBootstrap.Modal.Header className="pt-2 pb-1 ps-2 pe-3" closeButton={true}>
            <Title level={1} icon={IconStatus} color="yellow" label={words.confirmCounts} />
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body ref={bodyRefAction1} className="p-0">
            <div className="p-2">
              <BudgetOperationTopAction2 budgetOperation={budgetOperation} />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer className="p-2">
            <div>
              <Button label={words.yes} color="yellow" onClick={submitAction1} />
            </div>
            <div>
              <Button label={words.no} color="blue" onClick={cancelAction} />
            </div>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal> :
        null
      }
      {action && action.index === 2 ?
        <ReactBootstrap.Modal
          show={true}
          onHide={() => cancelAction({})}
          scrollable={true}
          centered={true}
         
        >
          <ReactBootstrap.Modal.Header className="pt-2 pb-1 ps-2 pe-3" closeButton={true}>
            <Title level={1} icon={IconStatus} color="green" label={words.sendCounts} />
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body ref={bodyRefAction2} className="p-0">
            <div className="p-2">
              <BudgetOperationTopAction3 budgetOperation={budgetOperation} />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer className="p-2">
            <div>
              <Button label={words.yes} color="green" onClick={submitAction2} />
            </div>
            <div>
              <Button label={words.no} color="blue" onClick={cancelAction} />
            </div>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal> :
        null
      }
    </div>
  );
})

export default BudgetOperationTop;
